module.exports = __webpack_public_path__ + "static/media/TN-Men-Tshirts-v2.0.b62577a8.svg";